import { getGoodsAndServicesTemplate } from "@/api/template";
import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import FileUploader from "@/components/FileUploader/FileUploader";
import CapitalGoodsIcon from "@/components/icons/CapitalGoodsIcon";

export default function UploadGoodsAndServices({ year }: { year?: number }) {
  return (
    <FileUploader
      uploadType={"goods_and_services"}
      buttonText={""}
      templateUrlFn={getGoodsAndServicesTemplate}
      uploadDataTableProps={{
        columns: [
          { key: "facility_name", label: "Facility name" },
          { key: "name", label: "Name" },
          { key: "quantity", label: "Quantity" },
          { key: "unit", label: "Unit" },
        ],
        rowKey: "name",
      }}
      uploadParameters={{
        year: year,
      }}
      customRender={(props) => (
        <ActionsPopOverItem
          icon={<CapitalGoodsIcon />}
          black
          {...props}
        >
          Goods & services
        </ActionsPopOverItem>
      )}
    />
  );
}
